
const state = {
  inEdit: false,
  field: null
}

const getters = {
}

const actions = {
  updateTextFieldState ({commit}, data) {
    commit('updateTextFieldState', data)
  }
}

const mutations = {
  updateTextFieldState (state, data) {
    state.inEdit = data.inEdit
    state.field = data.inEdit ? data.field : null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/text_field.js